import { handleErrorSnackbar, showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useCallback } from 'react';
import { useMissionsTranslation, useShiftStorage } from '../../../../ui/hooks';
import { useShiftWizardSteps } from './useShiftWizardSteps';
export const useDuplicateShift = ({ missionId, duplicatedShiftId, shiftData }) => {
    const { t } = useMissionsTranslation();
    const shiftStorage = useShiftStorage();
    const { shiftWizardSteps } = useShiftWizardSteps(undefined, { isDuplicate: true });
    if (!missionId) {
        throw new Error(t('errors.missionIdRequired'));
    }
    const handleSubmit = useCallback((data) => {
        return shiftStorage
            .post({
            action: 'create',
            data: Object.assign(Object.assign({ missionId }, data), { duplicatedShiftId }),
        })
            .then(() => {
            showInfoSnackbar({
                message: t('shifts.created'),
                autoHideDuration: 2000,
            });
        })
            .catch(handleErrorSnackbar);
    }, [t, shiftStorage, missionId, duplicatedShiftId]);
    const wizardConfig = {
        steps: shiftWizardSteps,
        title: t('shifts.duplicateShift'),
        data: shiftData,
        submitButtonLabel: t('shifts.finishLabel'),
        closeWizardContent: t('wizard.closeWizardContentEdit'),
        onSubmit: handleSubmit,
    };
    return {
        wizardConfig,
    };
};
